import { Component, ElementRef, ViewChild } from '@angular/core';
import { AppMenuComponent } from './app-menu.component';
import { LayoutService } from '@/core/layout/service/layout.service';
import { RouterModule } from '@angular/router';
import { AppMenuProfileComponent } from './app-menu-profile.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [AppMenuComponent, RouterModule, AppMenuProfileComponent, CommonModule],
    template: ` <div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
        <div class="layout-sidebar-top">
            <a href="/">
                <img src="/images/logo/sidebar-logo.png" alt="logo" class="layout-sidebar-logo" />
                <img src="/images/logo/sidebar-logo-slim.png" alt="logo" class="layout-sidebar-logo-slim" style="width: 40px; height: auto;" />
            </a>
            <button class="layout-sidebar-anchor" type="button" (click)="anchor()"></button>
        </div>
        <app-menu-profile *ngIf="menuProfilePosition === 'start'"></app-menu-profile>
        <div class="layout-menu-container">
            <app-menu></app-menu>
        </div>
        <app-menu-profile *ngIf="menuProfilePosition === 'end'"></app-menu-profile>
    </div>`
})
export class AppSidebarComponent {
    timeout: any = null;

    @ViewChild(AppMenuComponent) appMenu!: AppMenuComponent;

    constructor(
        public layoutService: LayoutService,
        public el: ElementRef
    ) {}

    get menuProfilePosition() {
        return this.layoutService.layoutConfig().menuProfilePosition;
    }

    onMouseEnter() {
        if (!this.layoutService.layoutState().anchored) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }

            this.layoutService.layoutState.update((state) => {
                if (!state.sidebarActive) {
                    return {
                        ...state,
                        sidebarActive: true
                    };
                }
                return state;
            });
        }
    }

    onMouseLeave() {
        if (!this.layoutService.layoutState().anchored) {
            if (!this.timeout) {
                this.timeout = setTimeout(() => {
                    this.layoutService.layoutState.update((state) => {
                        if (state.sidebarActive) {
                            return {
                                ...state,
                                sidebarActive: false
                            };
                        }
                        return state;
                    });
                }, 300);
            }
        }
    }

    anchor() {
        this.layoutService.layoutState.update((state) => ({
            ...state,
            anchored: !state.anchored
        }));
    }
}
